import { defineMessages } from 'react-intl-next';

const messages: {
    moveItemDown: {
        defaultMessage: string;
        description: string;
        id: string;
    }; moveItemToBottom: {
        defaultMessage: string;
        description: string;
        id: string;
    }; moveItemToTop: {
        defaultMessage: string;
        description: string;
        id: string;
    }; moveItemUp: {
        defaultMessage: string;
        description: string;
        id: string;
    }; newLozenge: {
        defaultMessage: string;
        description: string;
        id: string;
    }; reorderItemDropdown: {
        defaultMessage: string;
        description: string;
        id: string;
    }; sites: {
        defaultMessage: string;
        description: string;
        id: string;
    }; skeleton3pLoaderAriaLabel: {
        defaultMessage: string;
        description: string;
        id: string;
    }; skeletonLoaderAriaLabel: {
        defaultMessage: string;
        description: string;
        id: string;
    }; tryLozenge: {
        defaultMessage: string;
        description: string;
        id: string;
    };
} = defineMessages({
	newLozenge: {
		id: 'fabric.atlassianSwitcher.newLozenge',
		defaultMessage: 'New',
		description: 'The lozenge text for a lozenge indicating a new switcher item',
	},
	tryLozenge: {
		id: 'fabric.atlassianSwitcher.tryLozenge',
		defaultMessage: 'Try',
		description: 'Alternative lozenge text for a lozenge indicating a new switcher item',
	},
	sites: {
		id: 'fabric.atlassianSwitcher.sites',
		defaultMessage: '{productName} {numSites, plural, one {site} other {sites}}',
		description: 'The text of a toggle showing or hiding more site options',
	},
	skeletonLoaderAriaLabel: {
		id: 'fabric.atlassianSwitcher.skeletonLoaderAriaLabel',
		defaultMessage: 'The App Switcher is loading',
		description: 'The aria-label for the app switcher skeleton loader primitive',
	},
	skeleton3pLoaderAriaLabel: {
		id: 'fabric.atlassianSwitcher.skeleton3pLoaderAriaLabel',
		defaultMessage: 'The App Switcher third party section is loading',
		description: 'The aria-label for the app switcher third party skeleton loader primitive',
	},
	reorderItemDropdown: {
		id: 'fabric.atlassianSwitcher.reorderItemDropdown',
		defaultMessage: 'Reorder menu item',
		description: 'The text of a button to reorder an item in the switcher',
	},
	moveItemUp: {
		id: 'fabric.atlassianSwitcher.moveItemUp',
		defaultMessage: 'Move up',
		description: 'The text of a button to move an item up in the switcher',
	},
	moveItemDown: {
		id: 'fabric.atlassianSwitcher.moveItemDown',
		defaultMessage: 'Move down',
		description: 'The text of a button to move an item down in the switcher',
	},
	moveItemToTop: {
		id: 'fabric.atlassianSwitcher.moveItemToTop',
		defaultMessage: 'Move to top',
		description: 'The text of a button to move an item to the top in the switcher',
	},
	moveItemToBottom: {
		id: 'fabric.atlassianSwitcher.moveItemToBottom',
		defaultMessage: 'Move to bottom',
		description: 'The text of a button to move an item to the bottom in the switcher',
	},
});

export default messages;
